import { render } from "./SmallScreenGalleryLayout.vue?vue&type=template&id=024fb04f"
import script from "./SmallScreenGalleryLayout.vue?vue&type=script&lang=js"
export * from "./SmallScreenGalleryLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__